import * as React from 'react';
import { SVGProps } from 'react';

export const RulerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_8235_93329)">
      <path
        d="M9.06055 3.19678L10.4745 4.61078"
        stroke="#071114"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.93945 5.31812L8.35345 6.73211"
        stroke="#071114"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.81787 7.43945L6.23187 8.85345"
        stroke="#071114"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.69678 9.56055L4.11078 10.9745"
        stroke="#071114"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.92882 11.3286L10.8288 1.42858C10.8288 1.42858 11.5355 0.721909 12.2422 1.42858L15.0708 4.25724C15.0708 4.25724 15.7775 4.96391 15.0708 5.67124L5.17082 15.5712C5.17082 15.5712 4.46415 16.2779 3.75749 15.5712L0.92882 12.7426C0.92882 12.7426 0.222154 12.0359 0.92882 11.3286Z"
        stroke="#071114"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8235_93329">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default RulerIcon;
